import React from 'react'
import { StyleSheet, View } from 'react-native'
import { RiderPanel } from './RiderPanel'
import { Controller, UseFieldArrayReturn, UseFormReturn } from 'react-hook-form'
import { InquiryComplaintData, RiderAlterationFormData } from '../../service/model'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { makeRootStyles } from '../../shared/styles'
import { useTranslation } from 'react-i18next'
import { SelectSearch } from '../select-search'
import { assets } from '../../assets'
import { InputTable } from '../table/input'
import { pipe } from 'fp-ts/lib/function'
import * as O from 'fp-ts/lib/Option'
import { RiderAlterationService } from '../../service'
type PolicyBenefitRegistrationBlockProps = {
  isConfirmed: boolean
  riderAlterationForm: UseFormReturn<RiderAlterationFormData.RiderAlteration>
  NewRiderLAList: UseFieldArrayReturn<RiderAlterationFormData.RiderAlteration, 'newRiderLAList', 'id'>
  riderNameList: RiderAlterationService.RiderNameInfo[]
  setIsDeletedNewLAForBenefitsRegistration?: (status: { status: boolean; index: number }) => void
  onCheckBenefitsRegistrationEvent?: (checkedValue: boolean, checkedIndex: number) => void
  onViewLADetailEvent: (index: number) => void
}
export const PolicyBenefitRegistrationBlock = (props: PolicyBenefitRegistrationBlockProps) => {
  const { t, i18n } = useTranslation()
  const { riderAlterationForm,
    NewRiderLAList,
    isConfirmed,
    onCheckBenefitsRegistrationEvent,
    onViewLADetailEvent,
    setIsDeletedNewLAForBenefitsRegistration,
    riderNameList
  } = props
  const tableClasses = makeRootStyles()
  const getRiderOptionsForBenefitsRegistration = (riderList: RiderAlterationService.RiderNameInfo[]) => {
    const riderOptions = pipe(
      O.fromNullable(riderList),
      O.map((list) => list.filter((item) => item.code === 'BEN001').map((item) => ({ label: i18n.language === 'en' ? item.name : item.nameVi, value: item.code }))),
      O.getOrElse(() => [] as { label: string, value: string }[])
    )
    return riderOptions
  }
  return (
    <View>
      {NewRiderLAList.fields.map((fieldItem, index) => {
        return (
          <RiderPanel
            key={index}
            containerStyle={benefitStyles.panelContent}
            title={fieldItem.LAName}
            isNoPadding={true}
            isExpandedToggle={true}
            isNewLA={fieldItem.isNewLA}
            viewDetailEvent={onViewLADetailEvent}
            isCheckedBenefitsRegistration={fieldItem.isCheckedBenefitsRegistration}
            hasShowedBenefitsRegistration={true}
            isNewLAForBenefitsRegistration={fieldItem.isNewLAForBenefitsRegistration}
            LAIndex={index}
            onCheckBenefitsRegistrationEvent={onCheckBenefitsRegistrationEvent}
            isViewDetail={isConfirmed}
            setIsDelete={(status: boolean, index: number) => setIsDeletedNewLAForBenefitsRegistration && setIsDeletedNewLAForBenefitsRegistration({ status: status, index: index })}
          >
            {fieldItem.isCheckedBenefitsRegistration && (
              <TableContainer className={tableClasses.container}>
                <Table className={tableClasses.root}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={tableClasses.tableCell1}>
                        {t('requestInfo:RiderName')}
                      </TableCell>
                      <TableCell className={tableClasses.tableCell1}>
                        {t('requestInfo:SumAssured')}
                      </TableCell>
                      <TableCell className={tableClasses.tableCell1}>
                        {t('RiderAlteration:PolicyPeriod')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className={tableClasses.tableCell1}>
                        <Controller
                          control={riderAlterationForm.control}
                          name={`newRiderLAList.${index}.benefitsRegistrationRiderInfo.riderName`}
                          render={({ field: { value, onChange, onBlur } }) => (
                            <SelectSearch
                              options={getRiderOptionsForBenefitsRegistration(riderNameList)}
                              value={value}
                              onChange={(val) => {
                                onChange(val)
                              }}
                              onBlur={onBlur}
                              disabled={true}
                              popupIcon={<assets.ArrowDownDropdownIcon />}
                            />
                          )}
                        />

                      </TableCell>
                      <TableCell className={tableClasses.tableCell1}>
                        <Controller
                          control={riderAlterationForm.control}
                          name={`newRiderLAList.${index}.benefitsRegistrationRiderInfo.sumAssured`}
                          render={({ field: { value, onChange, onBlur } }) => (
                            <InputTable
                              value={String(value)}
                              onChange={onChange}
                              onBlur={onBlur}
                              inputType={'money'}
                              disabled={true}
                            />
                          )}
                        />

                      </TableCell>
                      <TableCell className={tableClasses.tableCell1}>
                        <Controller
                          control={riderAlterationForm.control}
                          name={`newRiderLAList.${index}.benefitsRegistrationRiderInfo.policyPeriod`}
                          render={({ field: { value, onChange, onBlur } }) => (
                            <InputTable
                              value={String(value)}
                              onChange={onChange}
                              onBlur={onBlur}
                              inputType={'money'}
                              disabled={true}
                            />
                          )}
                        />

                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </RiderPanel>
        )
      })}
    </View>
  )
}
const benefitStyles = StyleSheet.create({
  panelContent: {
    backgroundColor: '#fff',
    // marginTop: 20,
    borderWidth: 0,
    borderColor: '#fff'
  },
  btnNewLA: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  btnAdd: {
    minHeight: 40,
    width: '100%',
    borderRadius: 100,
    paddingHorizontal: 25,
    paddingVertical: 10,
    borderColor: '#ED1B2E',
    borderWidth: 1
    // backgroundColor: '#ED1B2E'
  },
  btn_text: {
    fontSize: 15,
    lineHeight: 20,
    color: '#ED1B2E',
    fontWeight: 'bold'
  },
})